import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root',
})
export class SuitecrmService {
  private empresaConfig: any;
  constructor(private _http: HttpClient, private configService: ConfigService) {
    this.empresaConfig = this.getEmpresa();
  }


  listarCodigos(): Observable<any> {
    return this._http.get('assets/codes_phones.json');
  }
  obtenerVendedor(ciudad: string, data: any): Observable<any> {
    return this._http
      .get(this.empresaConfig.urlCrm, {
        params: {
          entryPoint: 'Call_SP_EntryPoint',
          action: 'obtener_vendedor_turno_cliente',
          kv: 'y',
          len: 4,
          param1: ciudad,
          param2: data.attributes.first_name,
          param3: data.attributes.last_name,
          param4: data.attributes.phone_mobile,
        },
      })
      .pipe(
        map((result: any) => {
          if (result.data && result.data.length > 0) {
            return result.data[0];
          } else {
            throw new Error('No existe parametros de turnos.');
          }
        })
      );
  }

  obtenerDiasVigencia(): Observable<any> {
    return this._http
      .get(this.empresaConfig.urlCrm, {
        params: {
          entryPoint: 'Call_SP_EntryPoint',
          action: 'listar_tipo_prospecto',
          kv: 'y',
        },
      })
      .pipe(
        map((result: any) => {
          if (result.data) {
            let o = result.data.find((elem: any) => elem.name == 'NORMAL');
            if (o.tiempo_de_vigencia_dma == 'DAY') {
              return Number(o.tiempo_de_vigencia_cantidad);
            }
            if (o.tiempo_de_vigencia_dma == 'MONTH') {
              return Number(o.tiempo_de_vigencia_cantidad) * 30;
            }
            if (o.tiempo_de_vigencia_dma == 'YEAR') {
              return Number(o.tiempo_de_vigencia_cantidad) * 365;
            }
          }
          return 0;
        })
      );
  }
  listarPaises(): Observable<any> {
    return this._http
      .get(this.empresaConfig.urlCrm, {
        params: {
          entryPoint: 'Call_SP_EntryPoint',
          action: 'listar_par_paises',
          kv: 'y',
        },
      })
      .pipe(
        map((result: any) => {
          let paises: any[] = [];
          let i = 0,
            j = 0,
            k = 0;
          result.data.forEach((a: any) => {
            i = paises
              .map(function (elem) {
                return elem.abr_pais;
              })
              .indexOf(a.abr_pais);
            if (i < 0) {
              paises.push({ abr_pais: a.abr_pais, pais: a.pais, estados: [] });
            }
            i = paises
              .map(function (elem) {
                return elem.abr_pais;
              })
              .indexOf(a.abr_pais);
            j = paises[i].estados
              .map(function (elem: any) {
                return elem.abr_estado;
              })
              .indexOf(a.abr_estado);
            if (j < 0 && a.estado != 'S/D') {
              paises[i].estados.push({
                abr_estado: a.abr_estado,
                estado: a.estado,
                regiones: [],
              });
            }
          });
          return paises;
        })
      );
  }
  getToken(): Observable<any> {
    return this._http.post<any>(
      this.empresaConfig.urlCrm + '/Api/access_token',
      this.empresaConfig.credential
    );
  }
  //POST {{suitecrm.url}}/Api/V8/module
  crearLead(record: any, token: string): Observable<any> {
    let name = record.attributes.first_name;
    if (record.attributes.last_name) {
      name = name + ' ' + record.attributes.last_name;
    }
    if (record.attributes.last_name2_c) {
      name = name + ' ' + record.attributes.last_name2_c;
    }
    record.attributes.first_name = record.attributes.first_name?.trim();
    record.attributes.last_name = record.attributes.last_name?.trim();
    record.attributes.last_name2_c = record.attributes.last_name2_c?.trim();
    record.attributes.name = name;
    if (record.attributes.primary_address_state == '') {
      record.attributes.primary_address_state = '00';
    }
    record.attributes.name = record.attributes.name?.trim();
    record.attributes.account_name = record.attributes.name;
    return this._http
      .post<any>(
        this.empresaConfig.urlCrm + '/Api/V8/module',
        { data: this.clonar(record) },
        { headers: { Authorization: 'Bearer ' + token } }
      )
      .pipe(
        map((result: any) => {
          return result.data;
        })
      );
  }

  clonar(record: any): any {
    let data = { type: record.type, attributes: {} };
    if (record.id) {
      Object.defineProperty(data, 'id', { value: record.id, enumerable: true });
    }
    if (record.attributes) {
      for (let [key, value] of Object.entries(record.attributes)) {
        if (value && !(value instanceof Object)) {
          Object.defineProperty(data.attributes, key, {
            value: value,
            enumerable: true,
          });          
        }
      }
    }
    return data;
  }
  getEmpresa() {
    const sociedadActiva = this.configService.getSociedadActiva();
    return environment.empresas.find((value) => { return value.sociedad == sociedadActiva });
  }
}
